function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus?.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      option.setAttribute('selected', true);
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.countryContainer  = options['countryContainer'] ? document.getElementById(options['countryContainer']) : this.countryEl.closest('div');
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.countryContainer.classList.add('has-no-province');
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.countryContainer.classList.remove('has-no-province');
      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '');

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    const parts = (number = (number / 100).toFixed(precision)).split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
  }

  return formatString.replace(placeholderRegex, value);
}

class AccordionItem extends HTMLElement {
  constructor() {
    super();

    this.container = this.parentElement;
    this.siblings = Array.from(this.container.querySelectorAll('accordion-item')).filter(child => child !== this);
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.handleClick = this.toggle.bind(this);
    this.handleOpenAttributes = this.updateAttributes.bind(this, true);
    this.handleCloseAttributes = this.updateAttributes.bind(this, false);

    if (this.isOpen()) {
      setTimeout(() => this.open());
    }
  }

  connectedCallback() {
    this.timeline = this.buildTimeline();
    this.summary.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.timeline.kill();
    this.summary.removeEventListener('click', this.handleClick);
  }

  buildTimeline() {
    return gsap.timeline({
      paused: true,
      onStart: this.handleOpenAttributes,
      onReverseComplete: this.handleCloseAttributes,
    }).fromTo(this.content, {
      height: 0,
      autoAlpha: 0,
    }, {
      height: 'auto',
      autoAlpha: 1,
      duration: 0.4,
      ease: 'power2.inOut',
    });
  }

  isOpen() {
    return this.details.hasAttribute('open');
  }

  open() {
    this.siblings?.forEach(sibling => sibling.close());
    this.timeline.play();
  }

  close() {
    this.details.classList.remove('is-open');
    this.timeline.reverse();
  }

  updateAttributes(open = true) {
    this.details.classList.toggle('is-open', open);
    this.details.toggleAttribute('open', open);
    this.summary.setAttribute('aria-expanded', open);
  }

  toggle(e) {
    e?.preventDefault();

    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('accordion-item', AccordionItem);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.productContainer = this.closest('.product');

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  updatePrice() {
    if (this.productContainer) {
      this.unitPriceElement = this.productContainer.querySelector('[data-unit-price]');
      this.subtotalElements = this.productContainer.querySelectorAll('[data-subtotal]');
    }

    if (this.unitPriceElement) {
      this.unitPrice = this.unitPriceElement.dataset.unitPrice;
      this.subscriptionPrice = this.unitPriceElement.dataset.subscriptionPrice;
    }

    if (!this.unitPrice) return;

    const subscriptionCheckbox = this.productContainer.querySelector('.rc-checkbox__input');
    let unitPrice = this.unitPrice;

    if (subscriptionCheckbox && subscriptionCheckbox.checked) {
      unitPrice = this.subscriptionPrice;
    }

    for (const subtotalElement of this.subtotalElements) {
      subtotalElement.textContent = Shopify.formatMoney(unitPrice * this.input.value);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.productContainer) this.updatePrice();
  }
}

customElements.define('quantity-input', QuantityInput);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.closest('.header-wrapper').getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--menu-drawer-footer-height', `${parseInt(this.querySelector('[data-tertiary-menu]').offsetHeight)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);

    if (event === undefined) return;

    this.header.classList.remove('menu-open');
  }

  onSummaryClick(event) {
    super.onSummaryClick(event);

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuItem = detailsElement.closest('.has-children');

    if (parentMenuItem) {
      const children = detailsElement.querySelectorAll('.menu-drawer__list-item');
      
      if (children.length) {
        gsap.set(children, { height: parentMenuItem.offsetHeight });
      }
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.getOverlay();
    this.mql = window.matchMedia('(min-width: 750px)');
    this.handleHide = this.hide.bind(this);
    this.handleClick = this.onClick.bind(this);
    this.handleKeyUp = this.onKeyUp.bind(this);
    this.handleOpenAttributes = this.updateAttributes.bind(this, true);
    this.handleCloseAttributes = this.updateAttributes.bind(this, false);
    this.handleMediaQueryChange = this.buildTimeline.bind(this);
  }

  connectedCallback() {
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.handleHide);
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keyup', this.handleKeyUp);
    this.mql.addEventListener('change', this.handleMediaQueryChange);

    if (this.moved) {
      this.buildTimeline();
    } else {
      this.moved = true;
      document.body.appendChild(this);
    }
  }

  disconnectedCallback() {
    this.timeline?.kill();
    this.querySelector('[id^="ModalClose-"]').removeEventListener('click', this.handleHide);
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keyup', this.handleKeyUp);
    this.mql.removeEventListener('change', this.handleMediaQueryChange);
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.hide();
  }

  onClick(event) {
    if (event.target === this) this.hide();
  }

  buildTimeline() {
    if (this.timeline) this.timeline.kill();

    this.timeline = gsap.timeline({
      paused: true,
      onStart: this.handleOpenAttributes,
      onReverseComplete: this.handleCloseAttributes,
    }).from(this.firstElementChild, {
      scale: 0.7,
      autoAlpha: 0,
      duration: 0.2,
      ease: 'power1.inOut',
    });

    if (this.isOpen()) {
      this.timeline.progress(1);
    }
  }

  updateAttributes(open = true) {
    document.body.classList.toggle('overflow-hidden', open);
    document.body.classList.toggle('has-open-modal', open);
    document.body.classList.toggle('has-open-dialog', open);
    this.toggleAttribute('open', open);

    if (open) {
      setTimeout(() => {
        trapFocus(this, this.querySelector('[role="dialog"]'));
      }, 100);
    } else {
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
    }
  }

  getOverlay() {
    const overlay = document.querySelector('[data-modal-overlay]');

    if (overlay) return overlay;

    const overlayElement = document.createElement('div');
    overlayElement.classList.add('modal-overlay', 'modal-overlay--primary');
    overlayElement.dataset.modalOverlay = true;
    document.body.appendChild(overlayElement);

    return overlayElement;
  }

  isOpen() {
    return this.hasAttribute('open');
  }

  show(opener) {
    this.openedBy = opener;

    this.overlay.addEventListener('click', this.handleHide);

    const popup = this.querySelector('.template-popup');
    if (popup) popup.loadContent();

    window.pauseAllMedia();
    this.timeline.play();
  }

  hide() {
    this.overlay.removeEventListener('click', this.handleHide);

    document.body.classList.remove('has-open-dialog');

    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    this.timeline.reverse();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const disable = this.dataset.disable;
    const button = this.querySelector('button');
    const disabledMQL = disable ? window.matchMedia(disable) : null;

    if (!button) return;
    button.addEventListener('click', () => {
      if (disabledMQL && disabledMQL.matches) return;

      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.sliderControlButtons = Array.from(this.querySelectorAll('.slider-counter__link'));
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.loop = this.dataset.loop === 'true';

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.sliderControlButtons.length) {
      this.sliderControlButtons.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    } 

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemsVisible = this.getVisibleSlides();
    this.sliderWidth = this.slider.offsetWidth - this.sliderItemsToShow[0].offsetLeft
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    this.sliderItemsVisible = this.getVisibleSlides();

    const previousPage = this.currentPage;
    this.currentPage = Math.round((this.slider.scrollLeft / this.sliderItemOffset) || 0) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.sliderControlButtons.length) {
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });

      const activeControlButton = this.sliderControlButtons[this.currentPage - 1];

      if (activeControlButton) {
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
      }
    }

    if (this.enableSliderLooping) return;

    if (this.prevButton) {
      if (this.sliderItemsVisible === this.sliderItems.length) {
        this.prevButton.setAttribute('aria-hidden', 'true');
      } else {
        this.prevButton.setAttribute('aria-hidden', 'false');
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }
      }
    }

    if (this.nextButton) {
      if (this.sliderItemsVisible === this.sliderItems.length) {
        this.nextButton.setAttribute('aria-hidden', 'true');
      } else {
        this.nextButton.setAttribute('aria-hidden', 'false');
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          if (this.loop) {
            this.nextButton.classList.add('slider-button--loop')
          } else {
            this.nextButton.setAttribute('disabled', 'disabled');
          }
        } else {
          if (this.loop) {
            this.nextButton.classList.remove('slider-button--loop')
          } else {
            this.nextButton.removeAttribute('disabled');
          }
        }
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    if (element.offsetWidth > this.sliderWidth) {
      return (element.offsetLeft - this.slider.scrollLeft <= this.sliderItemsToShow[0].offsetLeft)
    }

    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  getVisibleSlides() {
    let visibleSlides = 0;
    this.sliderItemsToShow.forEach(item => visibleSlides += this.isSlideVisible(item) ? 1 : 0);

    return visibleSlides;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || Math.max(this.slidesPerPage, 1);
    if (event.currentTarget.name === 'next') {
      this.slideScrollPosition = event.currentTarget.classList.contains('slider-button--loop') ? 0 : this.slider.scrollLeft + (step * this.sliderItemOffset)
    } else {
      this.slideScrollPosition = this.slider.scrollLeft - (step * this.sliderItemOffset)
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlButtons.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalMediaSliders = document.querySelectorAll(`#ProductModal-${this.dataset.section} .slider`);
    if (modalMediaSliders.length === 0) return;

    modalMediaSliders.forEach(slider => {
      const newMediaModal = slider.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"], [data-target="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
      slider.prepend(newMediaModal);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const subscriptionCheckbox = document.querySelector(`#RechargeWidget_${this.dataset.productId} .rc-checkbox__input`);
    let sellingPlan = null;

    if (window.location.pathname === this.dataset.url) {
      const params = new URLSearchParams(window.location.search);
      sellingPlan = params.get('selling_plan');
    } else if (subscriptionCheckbox && subscriptionCheckbox.checked) {
      const sellingPlanSelect = document.querySelector(`#RechargeWidget_${this.dataset.productId} .rc-selling-plans select`);

      if (sellingPlanSelect) {
        sellingPlan = sellingPlanSelect.value;
      }
    }

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}${sellingPlan ? '&selling_plan=' + sellingPlan : ''}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const unitPriceElement = source?.querySelector('[data-unit-price]');

        if (unitPriceElement) {
          const quantity = document.getElementById(`Quantity-${this.dataset.section}`)?.value ?? 1;
          const subscriptionPrice = unitPriceElement.dataset.subscriptionPrice;          

          let unitPrice = unitPriceElement.dataset.unitPrice;
          if (subscriptionCheckbox && subscriptionCheckbox.checked) {
            unitPrice = subscriptionPrice;
          }

          const subtotalElements = this.closest('.product').querySelectorAll('[data-subtotal]');
  
          for (const subtotalElement of subtotalElements) {
            subtotalElement.textContent = Shopify.formatMoney(unitPrice * quantity);
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] .button__label');
    const addButtonSuffix = productForm.querySelector('[name="add"] .button__suffix');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) {
        addButtonText.textContent = text;
        addButtonSuffix.style.display = 'none';
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      addButtonSuffix.style.display = 'inline';
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] .button__label');
    const addButtonSuffix = button.querySelector('[name="add"] .button__suffix');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    addButtonSuffix.style.display = 'none';
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class MediaItem extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    this.poster = this.querySelector('.media__poster');
    this.playButton = this.querySelector('.media__play');
    this.handleClick = this.onClick.bind(this);
  }

  connectedCallback() {
    if (!this.video || !this.poster) return;

    this.playButton.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    if (!this.video || !this.poster) return;

    this.playButton.removeEventListener('click', this.handleClick);
  }

  onClick() {
    gsap.to(this.poster, {
      autoAlpha: 0,
      duration: 0.3,
    });

    this.video.play();
  }
}

customElements.define('media-item', MediaItem);

/**
 * Recharge
*/

// TODO: Clean this shit up

function initReChargeWidget(widgetContainer) {
  if (typeof widgetContainer === 'string') {
    widgetContainer = document.querySelector(widgetContainer);
  } else if (!widgetContainer) {
    widgetContainer = document.querySelector('.recharge-subscription-widget');
  }

  setupRechargeWidget(widgetContainer);
}

// Replace selling plan select element
function buildSellingPlanSelect(widgetContainer) {
  if (!widgetContainer.querySelector('.rc-widget')) return false;

  const sellingPlanSelect = widgetContainer.querySelector('.rc-selling-plans-dropdown__select, .rc-selling-plans__dropdown');

  if (!sellingPlanSelect) return;

  const params = new URLSearchParams(window.location.search);
  const sellingPlan = params.get('selling_plan');
  const selected = sellingPlanSelect.querySelector(`option[value="${sellingPlan}"]`) ?? sellingPlanSelect.querySelector('option');

  selected?.setAttribute('selected', 'selected');
  Select.bind(sellingPlanSelect);

  return true;
}

// Trigger callback on ReCharge checkbox change
// Defaults to JS replacement of the selling plan select element
// TODO: Consider updating this to be an event listener on checkbox `change` event
function createRechargeCheckboxObserver(widgetContainer, callback = buildSellingPlanSelect, unsetCallback = false) {
  const args = Object.values(arguments).slice(2);

  return new MutationObserver((mutationList, observer) => {
    let sellingPlanSelectAdded = null;
    for (const mutation of mutationList) {
      // TODO: Clean this up
      if (mutation.type === 'childList') {
        const targetNode = mutation.addedNodes[0] || mutation.removedNodes[0];

        if (targetNode?.classList?.contains('rc-selling-plans')) {
          if (mutation.addedNodes[0]?.classList?.contains('rc-selling-plans')) {
            sellingPlanSelectAdded = true;
          }
  
          const variantsEl = widgetContainer.closest('.product').querySelector('variant-radios, variant-selects');
          
          if (variantsEl) {
            variantsEl.renderProductInfo();
          }
        }
      }
    }

    if (sellingPlanSelectAdded === true) {
      callback(widgetContainer, ...args);
    } else if (sellingPlanSelectAdded === false && unsetCallback) {
      unsetCallback(widgetContainer, ...args);
    }
  });
}

function initRechargeCheckboxObserver(widgetContainer, observer) {
  const variantsEl = widgetContainer.closest('.product').querySelector('variant-radios, variant-selects');
  
  if (variantsEl) {
    variantsEl.renderProductInfo();
  }

  const checkboxContainer = widgetContainer.querySelector('.rc-template__checkbox');

  if (!checkboxContainer) {
    console.error('ReCharge: Checkbox not found');
    return;
  }

  observer.observe(checkboxContainer, {
    attributes: false,
    childList: true,
    subtree: true,
  });
}

function setupRechargeWidget(widgetContainer) {
  const rechargeCheckboxObserver = createRechargeCheckboxObserver(widgetContainer);

  // Trigger additional logic once ReCharge widget has been injected
  const rechargeBlockObserver = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        if (
          mutation.addedNodes[0]?.classList?.contains('rc-widget') ||
          mutation.addedNodes[0]?.classList?.contains('rc-container')
        ) {
          observer.disconnect();
          buildSellingPlanSelect(widgetContainer);
          initRechargeCheckboxObserver(widgetContainer, rechargeCheckboxObserver);
        }
      }
    }
  });

  // Trigger logic directly if ReCharge widget has already loaded, otherwise
  // run mutation observer to trigger logic once widget has been injected
  if (buildSellingPlanSelect(widgetContainer) !== false) {
    initRechargeCheckboxObserver(widgetContainer, rechargeCheckboxObserver);
  } else {
    rechargeBlockObserver.observe(widgetContainer, {
      attributes: false,
      childList: true,
      subtree: true,
    });
  }
}

// Custom select styles

const position = document.querySelector('.select__position');
const state = document.querySelector('.select__state');
const country = document.querySelector('.select__country');
const licenseState = document.querySelector('.select__license-state');

if (position) {
  Select.bind(position, { placeholder: 'Position' });
}

if (state) {
  Select.bind(state, { placeholder: 'State' });
}

if (country) {
  Select.bind(country, { placeholder: 'Country' });
}

if (licenseState) {
  Select.bind(licenseState, { placeholder: 'License State' });
}

// TODO: Move to utils file
const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

const callOnLoad = callback => {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
};